export default __webpack_public_path__ + "static/eOevkcjy-cfe99c0b44d4a4f5c1af7bc4f65f63de.svg";